<template>
    <div class="sabun-comp">
        <el-col :span="4" >
            <el-input v-model="sabun1" maxlength="3" minlength="3" @input="changeValue" @blur="trigger('blur')"  @change="trigger('change')"></el-input>
        </el-col>
        <el-col class="sp" :span="1">-</el-col>
        <el-col :span="4" >
            <el-input v-model="sabun2" maxlength="2" minlength="2" @input="changeValue" @blur="trigger('blur')"  @change="trigger('change')"></el-input>
        </el-col>
        <el-col class="sp" :span="1">-</el-col>
        <el-col :span="4" >
            <el-input v-model="sabun3" maxlength="5" minlength="5" @input="changeValue" @blur="trigger('blur')"  @change="trigger('change')"></el-input>
        </el-col>
    </div>
</template>
<script>

export default {
    props: {
        value: String
    },
    created() {
        
        //this.$set('value',this.value)
    },
    data() {
        return {
            sabun1: '',
            sabun2: '',
            sabun3: ''
        }
    },
    methods: {
        changeValue() {
            this.$emit('input', `${this.sabun1}-${this.sabun2}-${this.sabun3}`);
        },
        trigger( event ) {
            this.$emit( event );
        }
    },
    watch: {
        value(val) {
            
            let tels = val?.split('-')
            if(tels && tels.length > 0) {
                for(let i=0; i<tels.length; i++) {
                    this.$set(this,'sabun'+(i+1), tels[i])  
                }
            } else {
                this.sabun1 = val
            }
        }   
    },
}

</script>

<style>
.sabun-comp .sp { text-align: center; }
</style>